<script setup>
import {useModalsStore} from '@/stores/modals'

const props = defineProps({
    oldValue: String,
    newValue: String,
    mode: String,
    label: String
})

const modalsStore = useModalsStore()

// --- Methods ---
const showModal = (viewNew) => {
    modalsStore.show({
        componentName: 'HistoryCodeEditorModal',
        obj: {
            value: viewNew ? props.newValue : props.oldValue,
            mode: props.mode,
            label: props.label
        }
    })
}
</script>

<template>
    <div class="d-flex align-items-center">
        <button class="btn btn-sm btn-light" type="button" @click="showModal(false)">
            View old
        </button>
        <i class="mx-2 bi-chevron-right"/>
        <button class="btn btn-sm btn-light" type="button" @click="showModal(true)">
            View new
        </button>
    </div>
</template>